// JQuery Application module for the Logo Mock-up Tool
//
// https://github.com/cloudinary/pkg-cloudinary-jquery#jquery-plugin
var LMTAQA = (function() {
    var isModuleEnabled = true;
    /**
     * Configuration for Cloudnary service
     * @type {Object}
     */
     var cloudinaryConfig = {
       api_key: undefined,
       api_secret: undefined,
       cloud_name: undefined,
       upload_preset: undefined,
       secure: true
     };

    /**
     * Scale area. This is used as scale factor
     * @type {Object}
     */
    var scaleArea = {
        height: Math.round(window.innerHeight*0.4),
        width: Math.round(window.innerHeight*0.4)
    };

    var inputFileObject = undefined;

    /**
     * Uploaded logo data
     * @type {Object}
     */
    var loadedLogo = {
        original_size: {
          height: "auto",
          width: "auto"
        },
        transformed_size: {
          height: 0,
          width: 0,
          base_width: 0,
          scale: 1
        },
        url: undefined,
        secure_url: undefined,
        scalable_image_url: undefined,
        public_id: undefined,
        original_filename: undefined,
        desktop_product_url: undefined,
        desktop_zoom_product_url: undefined,
        composition_url_desktop: undefined,
        composition_url_desktop_zoom: undefined,
        img_real_width: undefined,
        img_real_height: undefined,
        proof_number: undefined,
        decoration_type: undefined
    };

    var decoTypeChosen = $('input:radio[name="properties[_Decoration type]"]:checked').val();

    /**
     * Hold the logo area data to generate the transformation
     * @type {[type]}
     */
    var logoAreaData = undefined;

    var tmpLogoScale = {
      logoSize: undefined,
      logo: undefined,
      sliceBar: undefined,
      btnType: undefined
    }

    /**
     * Session identifier
     * @type {String}
     */
    var sessionStorageIdentifier = 'LogoMockup';
    /**
     * Check if the storage is available
     * @param  {string} type Type of storage
     * @return {boolean}      Return if the storage is available
     */
    var storageAvailable = function(type) {
      try {
        var storage = window[type],
          x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
      }
      catch(e) {
        return false;
      }
    };

    /**
     * Method to retrieve the current storage handler
     * @return {object | undefined } Storage handler or undefined
     */
    var _getStorage = function() {
      var storage;
      if (storageAvailable('localStorage')) {
        storage = window['localStorage'];
      } else if (storageAvailable('sessionStorage')) {
        storage = window['sessionStorage'];
      }
      return storage;
    };

    /**
     * Save data to storage
     * @param  {string} name identifier to save the data
     * @param  {string} val  stringified data
     * @return {void}
     */
    var saveToStorage = function(name, val) {
      var storage = _getStorage();
      var identifier = sessionStorageIdentifier + '_' + name;
      try {
        storage.setItem(identifier, val);
      } catch (exception) {
        console.error('An error ocurred trying to save ' + identifier + ' to storage. ' + exception);
      }
    };

    /**
     * Retrieve data from storage
     * @param  {string} name identifier to retrieve data
     * @return {null|string}    The saved data or null
     */
    var getFromStorage = function(name) {
      var storage = _getStorage();
      var identifier = sessionStorageIdentifier + '_' + name;
      return storage.getItem(identifier);
    };

    /**
     * Centralised the loading spinner so every function can use it. If left visible it blocks the entire page,
     * so added the failsafe timer, which guarantees it comes down even if a callback
     * we are waiting on never fires.
     */
    var loadSpinner = (function() {
      var failsafeTimer = null;
      var clearFailsafe = function() {
        if (failsafeTimer) {
          clearTimeout(failsafeTimer);
          failsafeTimer = null;
        }
      };
      var hide = function() {
        clearFailsafe();
        $('.loading-container').hide();
      };
      return {
        show: function(maxMs) {
          var limit = maxMs || 20000;
          clearFailsafe();
          $('.loading-container').show();
          failsafeTimer = setTimeout(function() {
            console.warn('[LMT] Load spinner failsafe fired after ' + limit + 'ms - releasing the overlay.');
            hide();
          }, limit);
        },
        hide: hide
      };
    })();

    /**
     * Setups the configuration for the object
     * @return {void}
     */
    var setupConfig = function(config) {
      cloudinaryConfig = {
        "cloud_name": config.cloudinary.cloud_name,
        "api_key": config.cloudinary.api_key,
        "api_secret": config.cloudinary.api_secret,
        "upload_preset": config.cloudinary.upload_preset,
        "secure": config.cloudinary.secure
      };
      // Write the configuration parameters
      $.cloudinary.config(cloudinaryConfig);
      // Load the local storage configuration
      if (!storageAvailable('localStorage')) {
        if (!storageAvailable('sessionStorage')) {
          // No way to handle the data!
          // Throw an error and abort
          throw 'Error: No storage available. Cancel Cloundinary initialization';
        }
      }
    };

    /**
     * Initializes the elements for the product view page
     * @param  {object} config      Configuration object
     * @param  {object} imgLogoArea Logo area data
     * @return {[type]}             [description]
     */
    var initOnProductView = function(config, imgLogoArea) {
      try {
        setLogoArea(imgLogoArea);
        // Add values to the add to cart form
        _init(config);
        // Remove default input file
        $('#default-logo-upload').remove()
        return true;
      } catch (e) {
        // Remove logo mock-up tool input from product options
        $('#lmt-logo-upload').remove()
        console.log("Logo Mock-up Tool Cannot be Initialized");
        console.log(e);

        $('input[name="properties[_Add embroidered logo ?]"]:first').attr('checked', true);

        return false;
      }
    };

    function recreateCloudinaryFileuploadInput(input, parent) {
      _init(config);
    }

    /**
     * Base initialization of the library
     * @param  {[type]} config [description]
     * @return {[type]}        [description]
     */
    var _init = function(config)  {
      window.logoMockupInitialized = false;
      try {
        // Initialize configuration
        setupConfig(config);

        // Set form data attribute in input file
        var formData = {
          upload_preset: cloudinaryConfig.upload_preset
        };
        $("input.cloudinary-fileupload[type=file]").attr('data-form-data', JSON.stringify(formData));
        $('.cloudinary-fileupload').on('cloudinarydone', function(e, data){cloudinaryDoneEvent(e, data)});
        $('.cloudinary-fileupload').on('fileuploadfail', function(e, message) {fileUploadFail(e, message)});

        function cloudinaryDoneEvent(e, data) {

          var typeVal = $('label.radioClicked input').val();
          if (typeVal != "Embroidered" && typeVal != "Sample") {
            $('.allowedFiles').show().html('Allowed '+typeVal+' logo file types for this product are eps, ai, and svg');
          } else {
            $('.allowedFiles').hide();
          }
          // Display uploaded image
          var index = data.result.secure_url.lastIndexOf(".");
          var extension = data.result.secure_url.substring(index);
          var found = foundInList(".eps, .ai, .svg", extension);
          //console.log('found: ' + found, 'typeVal: '+typeVal);
          if  ( typeVal != "Embroidered" && typeVal != "Sample" && found == false )  {

            $('.addToCart').attr('disabled',true);
            highlightAlert(typeVal);
            $('.uploaded-photo-div').append('<img style="position: absolute; top: 1px; left: 1px;" src="https://cdn.shopify.com/s/files/1/0312/6537/files/disallowed.png?v=1677861932" />');
            return $(e.target).trigger('fileuploadfail', "Allowed logo file types for this product are eps, ai, and svg. Please select an allowed file type.");
          }
          // Temporary fix to EPS transformaiton issue
          // Leave this commented in case Cloudinary will issues with .EPS files again
          // if (extension === 'eps') {
          //   return $(e.target).trigger('fileuploadfail', "Image format EPS is not supported. Supported formats are: jpg, png, pdf, ai and psd");
          // }
          var scalable_image_url = data.result.secure_url.substring(0,index+1)+'png';

          setLogoData({
            original_size: {
              height: data.result.height,
              width: data.result.width
            },
            url: data.result.url,
            secure_url: data.result.secure_url,
            scalable_image_url: scalable_image_url,
            public_id: data.result.public_id,
            original_filename: data.result.original_filename
          });
          addLogoDesktop("add");
          // Set preview from script.js
          inputFileObject = e.currentTarget;
          setTimeout(function() {
            recreateCloudinaryFileuploadInput(e.target);
          }, 500);

        }

        /**
         * Extract the real error out of the Cloudinary Response.
         * On an upload failure the plugin passes its `data` object, not a
         * string, so the Cloudinary message was ignored and the user gets a generic
         * file not supported message
         */
        function getUploadErrorMessage(payload) {
          if (!payload) { return null; }
          if (jQuery.type(payload) === "string") { return payload; }
          var xhr = payload.jqXHR || payload;
          var body = (xhr && xhr.responseJSON) ? xhr.responseJSON : null;
          if (!body && xhr && xhr.responseText) {
            try { body = JSON.parse(xhr.responseText); } catch (err) { body = null; }
          }
          if (body && body.error && body.error.message) { return body.error.message; }
          if (jQuery.type(payload.errorThrown) === "string" && payload.errorThrown) {
            return payload.errorThrown;
          }
          return null;
        }

        function fileUploadFail(e, message) {
          var serverMessage = getUploadErrorMessage(message);
          console.error('[LMT] Logo upload failed:', serverMessage || '(no server message)', message);

          loadSpinner.hide();
          var logoScaleModal = $('#logoScaleModalDesktop');
          logoScaleModal.modal('hide');
          if(jQuery.type(message) === "string"){
              $('.allowedFiles').html(message);
          } else if (serverMessage && /format|invalid|unsupported/i.test(serverMessage)) {
              $('.allowedFiles').html("We couldn't read that file. Please re-save it and try again, or upload a different file. Allowed file types are: jpg, png, pdf, ai, eps, svg, and psd");
          } else {
              $('.allowedFiles').html('Image file format not allowed. Allowed file types are: jpg, png, pdf, ai, eps, svg, and psd');
          }
          $('.allowedFiles').show({
            complete: function() {
              $('.allowedFiles').focus();
            }
          });
          setTimeout(function() {
            recreateCloudinaryFileuploadInput(e.target);
          }, 500);
        }

        $("#editLogoBtn").on('click', function(e) {
          if($('input[value="Logo on file"]:checked').length > 0){
            $('#logoOnFileModal').modal('show');
            $('.user-create-account').hide();
            $('.user-login-form').show();
          }else{
            addLogoDesktop("edit");
          }
        });

        $('.showHelpModal').click(function() {
          var logoScaleModal = $('#logoScaleModalDesktop');
          $('#helpModal').modal({
              backdrop: 'static',
              keyboard: false
          });
          logoScaleModal.modal('hide');
          $('#helpModal').css('display','flex');
          $('#helpModal').modal('show');
        });

        $('#closeHelpModal').click(function() {
            var logoScaleModal = $('#logoScaleModalDesktop');
            $('#helpModal').modal('hide');
            logoScaleModal.modal('show');
        });

        window.logoMockupInitialized = true;
        console.log("Logo Mock-up Tool Initialized");
      } catch (e) {
        console.log(e);
        throw "Something went wrong trying to initialize LMTAQA library";
      }


      $(document).ready(function() {
        // Initialize cloudinary on input type file
        var maxFileSize = 5000000;
       
        if($.fn.cloudinary_fileupload !== undefined) {
          $("input.cloudinary-fileupload[type=file]").cloudinary_fileupload({
            // This is used to allow the input file element hold the submitted file data
            // in order to use it to be sent in the add to cart request
            autoUpload: false,
            replaceFileInput: false,
            maxFileSize: 5000000,
            loadImageMaxFileSize: 5000000,
            acceptFileTypes: /(\.|\/)(gif|jpe?g|png|pdf|ai|eps|svg|psd)$/i
          });

      



          
          /**
           * Cloudinary rejects SVGs missing an XML declaration
           * Prepend it before handing the file to the uploader.
           */
          function normalizeSvgFile(file, done) {
            var isSvg = /\.svg$/i.test(file.name || '') || file.type === 'image/svg+xml';
            if (!isSvg || typeof FileReader === 'undefined' || typeof Blob === 'undefined') {
              return done(file);
            }
            var reader = new FileReader();
            reader.onload = function(ev) {
              try {
                var text = String(ev.target.result).replace(/^\uFEFF/, '');
                if (text.indexOf('<svg') === -1 || /^\s*<\?xml[\s\S]*?\?>/.test(text)) {
                  console.log("done")
                  return done(file);
                }
                var patched = '<?xml version="1.0" encoding="UTF-8"?>\n' + text;
                var blob = new Blob([patched], { type: 'image/svg+xml' });
                var normalized;
                try {
                  normalized = new File([blob], file.name, { type: 'image/svg+xml' });
                } catch (err) {
                  blob.name = file.name;
                  normalized = blob;
                }
                console.log('[LMT] SVG was missing its XML declaration, normalized before upload:', file.name);
                done(normalized);
              } catch (err) {
                console.error('[LMT] SVG normalization failed, uploading the original file.', err);
                done(file);
              }
            };
            reader.onerror = function() {
              console.error('[LMT] Could not read SVG for normalization, uploading the original file.');
              done(file);
            };
            reader.readAsText(file, 'UTF-8');
          }

          $('.cloudinary-fileupload').bind('fileuploadadd', function (e, data) {
              loadSpinner.show();
              if(data.files[0].size < maxFileSize){
                  var typeVal = $('label.radioClicked input').val();
                  if (typeVal == "Embroidered" || typeVal == "Sample") {
                    $('.allowedFiles').hide();
                  }
                  normalizeSvgFile(data.files[0], function(fileToUpload) {
                    data.files[0] = fileToUpload;
                    data.submit();
                  });
              } else {
                  loadSpinner.hide();
                  $('#logoScaleModalDesktop').modal('hide');
                  $('#logoScaleModalMobile').modal('hide');
                  $('.allowedFiles').html("File size can't be greater than " + maxFileSize/1000000 + "MB");
                  $('.allowedFiles').show();
                  scrollTo(0, $('.allowedFiles').offset().top - 120);
              }
          });
        }
      });
    }

    /**
     * Save current uploaed data to the storage
     * @return {void}
     */
    var saveLogoToStorage = function() {
      // Save image data into sotrage
      saveToStorage('cloudinary_image', JSON.stringify(loadedLogo));
    };

    /**
     * Retrieve the current logo data from storage
     * @return {mixed} Return the object data if exist or false if there isn't data saved in the storage
     */
    var getLogoFromStorage = function() {
      var data = getFromStorage('cloudinary_image');
      if (data && data !== undefined && data !== null) {
        return JSON.parse(data);
      } else {
        return false;
      }
    };

    /**
     * Update the logo data and then run the callback method
     * @param  {object} data     New data to update the logo
     * @return {mixed}           The saved logo data
     */
    var setLogoData = function(data) {
      for (var key in data) {
        if (loadedLogo.hasOwnProperty(key) && data.hasOwnProperty(key)) {
          loadedLogo[key] = data[key];
        }
      }
      return loadedLogo;
    };

    /**
     * Retrieve logo data
     * @return {void} [description]
     */
    var getLogoData = function() {
      return loadedLogo;
    };

    /**
     * Set the scaled logo size
     * @param  {object} obj [description]
     * @return {void}     [description]
     */
    var setScaledSize = function (scaledSize, baseWidth, scale) {
      if (!scale) {
        scale = loadedLogo.transformed_size.scale;
      }

      loadedLogo.transformed_size = {
        width: scaledSize.width,
        height: scaledSize.height,
        base_width: baseWidth,
        scale: (scale) ? scale : 1
      };
    };

    /**
     * Get the url of the composition
     * @param  {string} productImgUrl    The product image url to be used as base of the composition
     * @param  {string} logoCloudinaryId The logo image cloudinary id to be used in the composition
     * @return {string | boolean}    Returns false if something went wrong. In other case returns the url of the composition.
     */
    var getProductWithLogo = function(productImgUrl, logoCloudinaryId) {
      if (loadedLogo.img_real_width == undefined || loadedLogo.img_real_height == undefined) {
        console.log('Image real width or height is not defined. Cannot generate the image composition');
        return;
      }
      var realW = loadedLogo.img_real_width;
      var realH = loadedLogo.img_real_height;
      var logoRealW = loadedLogo.original_size.width;
      var logoRealH = loadedLogo.original_size.height;
      var logoW =  parseInt((logoAreaData.w/100)*realW);

      var scale = loadedLogo.transformed_size.scale;
      if (logoRealW > logoRealH) {
        imgW = Math.round(logoW * scale)
        var auxScale = imgW/logoRealW;
        imgH = Math.round(logoRealH * auxScale);
      } else {
        imgH = Math.round(logoW * scale);
        var auxScale = imgH/logoRealH;
        imgW = Math.round(logoRealW * auxScale);
      }

      // Convert percentage values
      var x = parseInt((logoAreaData.x/100)*realW);
      var y = parseInt((logoAreaData.y/100)*realH);
      if (imgW < logoW) {
        x += Math.round((logoW - imgW)/2);
      }
      if (imgH < logoW) {
        y += Math.round((logoW - imgH)/2);
      }
      if (productImgUrl && productImgUrl.trim() !== '' && logoCloudinaryId && logoCloudinaryId.trim() !== '') {
        var url = $.cloudinary.image(productImgUrl, {
          transformation: [
            {
              width: imgW,
              height: imgH,
              gravity: 'center',
              overlay: logoCloudinaryId,
              effect: 'make_transparent'
            },
            {
              width: logoW,
              height: logoW,
              crop: 'crop',
              flags: 'layer_apply',
              gravity: 'north_west',
              x: x,
              y: y,
              format: 'png'
            }
          ],
          type: "fetch"
        });
        url = url.attr('src');
        return url;
      }
      return false;
    };

    /**
     * Upload the product image with the composition image if the module is enables or the default image if the module is disabled
     * @param  {String} [type] [description]
     * @return {[type]}                  [description]
     */
    var setProductImage = function(type) {
      if (type === undefined) {
        type = 'desktop'
      }
      var logo = getLogoData();
      var productImg, compositionUrl, selector;

      switch (type) {
        case 'zoom':
          productImg = 'desktop_zoom_product_url';
          compositionUrl = 'composition_url_desktop_zoom';
          selector = '.productPopup div.slick-slide.slick-current.slick-active[data-slick-index="0"] .productSlideImageWrapp img';
          break;
        case 'zoom-quote':
          productImg = 'desktop_zoom_product_url';
          compositionUrl = 'composition_url_desktop_zoom';
          selector = '.productPopup div.slick-slide.slick-current.slick-active[data-slick-index="0"] .pinch-zoom img';
          break;
        default:
          productImg = 'desktop_product_url';
          compositionUrl = 'composition_url_desktop';
          selector = '.slick-slide.slick-current.slick-active[data-slick-index="0"] .productSlideImageWrapp img';
      }
      var aux = {};
      if ($(selector).attr('src') === undefined) {
        selector = '.hg-product-image .swiper-slide.swiper-slide-active img';
      }
      var imageUrl = $(selector).attr('src');
      imageUrl = imageUrl.split('?')[0];
      // Set the product image url only if it is not the composition image from cloudinary
      if (imageUrl && imageUrl !== undefined && typeof(imageUrl) == 'string' && imageUrl.indexOf("http") == -1) {
        aux[productImg] = 'https:' + $(selector).attr('src');
        aux['img_real_width'] = $(selector).get(0).naturalWidth;
        aux['img_real_height'] = $(selector).get(0).naturalHeight;
        logo = setLogoData(aux);
      }
      var url = getProductWithLogo(logo[productImg], logo.public_id);
      if (url && url.trim() !== '') {
      var aux = {};
        aux[compositionUrl] = url
        logo = setLogoData(aux);
      }
      // Update the logo if the module is enabled
      if (isModuleEnabled) {
        $(selector).attr('src', logo[compositionUrl]);
        var index = logo.url.lastIndexOf(".");
        var fullName = logo.original_filename + '.' + logo.url.substring(index+1);
        if(typeof logo.decoration_type == "undefined"){
          logo.decoration_type = "";
        }

        // decoration type method getter
        
        if (type == 'desktop' && inputFileObject !== undefined && inputFileObject !== null) {
          setPreviewUploadImage({inputFileObject: inputFileObject, url: logo.scalable_image_url, name: fullName, decoration_type: logo.decoration_type});
          uploadFormLogoInput(inputFileObject);
        } else
            if (type == 'desktop') {
          setPreviewUploadImage({url: logo.scalable_image_url, name: fullName, decoration_type: logo.decoration_type}, false);
          uploadFormLogoInput();
        }
      } else {
        $(selector).attr('src', logo[productImg]);
      }
    };

    /**
     * Set the logo Area from string like "X-Y-W"
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    var setLogoArea = function (data) {
      var aux = data.split('-');
      if (aux.length === 3) {
        logoAreaData = {
          x: aux[0],
          y: aux[1],
          w: aux[2]
        }
      } else {
        throw "Logo Area data is not set. Current: " + data;
      }
    }

    /**
     * This methods set the add to cart form with the uploaded logo
     * @return {[type]} [description]
     */
    var uploadFormLogoInput = function(inputFileObject) {
      // Get logo data
      var logo = getLogoData();
     

      // Define div element to hold the Logo data
      var data = $('<div>').attr({
        id: 'div-logo-mockup-data',
        style: 'display: none'
      });
      // If input is defined clone the input data if is not defined then come from storage
      if (inputFileObject !== undefined && inputFileObject !== null) {
        $('#hidden_upload_your_logo_name').val(loadedLogo.secure_url);
        // Add Input File with logo image
        var inputFileObject = $(inputFileObject);
        var inputLogo = $('<input>').attr({
          id: 'logo-mockup-input',
          style: 'display: none',
          name: 'properties[_Upload your logo (2MB max)]',
          type: 'hidden',
          value: loadedLogo.secure_url
        });

        // Add input file
        data.append(inputLogo);
      } else {
        // set URL loaded from storage
        $('#hidden_upload_your_logo_name').attr('value',logo.secure_url);
      }

      // Add extra logo mock-up data
      data.append($('<input>').attr({
        type: 'hidden',
        id: 'LMTAQA-logo-composition',
        name: 'properties[_Logo mockup image]',
        value: logo.composition_url_desktop
      }));

      var aux = JSON.stringify({
        logo_cloudinary_id: logo.public_id,
        scale: loadedLogo.transformed_size.scale,
        base_width: loadedLogo.transformed_size.base_width,
        logo_width: loadedLogo.original_size.width,
        logo_height: loadedLogo.original_size.height,
        logo_url: loadedLogo.secure_url
      });

      // Remove old data
      $('div#div-logo-mockup-data').remove();
      // Add data
      $('div.upload-logo-file-div div.shappify_option_value input.cloudinary-fileupload[type="file"]').parent().append(data)

      // Set position selected
      var radioChecked =   $('.customize-accord.accord-sr-2 label.shappify_radio_option.radioClicked')

      if (radioChecked.length == 0) {
        // check the first radio option
        var options = $('.customize-accord.accord-sr-2 label.shappify_radio_option');
        
        if (options !== undefined && options !== null && options.length > 0) {
          options.first().click();
          // Select the Upload logo option
          var logoOtions = $('.customize-accord.accord-sr-3 label.shappify_radio_option');
          if (logoOtions !== undefined && options !== null && options.length > 0) {
            logoOtions.first().click();
            
          }
        }
      }
    }

    /**
     * Disable the logo preview display
     * @return {void}
     */
    var disableLogoDisplay = function() {
      isModuleEnabled = false;
      // Remove extra data
      $('div#div-logo-mockup-data').remove();
    }

    /**
     * Enable the logo preview display
     * @return {void} [description]
     */
    var enableLogoDisplay = function() {
      isModuleEnabled = true;
      // Set logo properties
      uploadFormLogoInput();
    }
    
    function foundInList(list, string) {
      const pos = list.indexOf(string);
      if( pos > -1 ) {
        return true;
      } else {
        return false;
      }
    }

    function setPreviewImageLogoOnFile(logo_url, logo_name){
        var html = '<div class="logo-on-file-selected-container">\n\
                        <div class="uploaded-photo">\n\
                          <div class="uploaded-photo-div">\n\
                            <div class="uploaded-photo-div-left">\n\
                              <span class="uploaded-img-span">\n\
                                <img src="'+logo_url+'" height="39"></span>\n\
                              <span class="uploaded-img-name">'+logo_name+'</span>\n\
                            </div>\n\
                            <div class="uploaded-photo-div-right">\n\
                              <span class="uploaded-img-editlink" onclick="showLoginModal()"> Edit</span>\n\
                            </div>\n\
                          </div>\n\
                          <input type="hidden" value="'+logo_url+'" id="hidden_logo_on_file" class="bold_option_child" name="properties[_Upload your logo (2MB max)]">\n\
                        </div>\n\
                    </div>';
        if($('.logo-on-file-selected-container').length > 0){
            $('.logo-on-file-selected-container').replaceWith(html);
        }else{
            $('input[value="Logo on file"]').parents('label').after(html);
        }
        $('.logo-on-file-selected-container').show();
    }
  
    /**
     * Get the data from the input and set the preview of the Logo in the "Choose your logo" section
     * @param  {object} input The input element reference
     * @return {voud}
     */
    var setPreviewUploadImageInput = function(logoData) {
      var input = logoData.inputFileObject;
      var url = logoData.url;
      var name = logoData.name;
      var decoration_type = logoData.decoration_type;
      var preview = document.getElementById('preview_uploaded_file');
      var currentLogoData = getLogoData();
  
      if (input.files && input.files[0]) {
        if(typeof($.fn.hasExtension) == 'undefined'){
          $.fn.hasExtension = function(exts) {
              return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$')).test($(this).val());
          }
        }

        if (!$(input).hasExtension(['.jpg','.jpeg','.png','.gif','.pdf','.eps','.ai','.svg','.psd'])) {
          $('.main-uploadlogo-container').addClass('invalid-file-error');
          $('.upload-logo-invalid-error').show();
        } else {
          console.log("FIRING");
          $('.upload-logo-invalid-error').hide();
          $('.main-uploadlogo-container').removeClass('invalid-file-error');
          $('.main-uploadlogo-container .uploaded-img-span').html('<img src='+url+' />');
          if (preview) { preview.setAttribute('src', url); }
          $('.main-uploadlogo-container').addClass('photo-exists').attr('data-photo',true);
          var tempUfileName = (name > 30) ? name.substring(0,30) + '...' : name;
          $('.main-uploadlogo-container .uploaded-img-name').text(tempUfileName);
          $('#hidden_upload_your_logo_name').val('');
        }

        if(currentLogoData){
          currentLogoData.isLogoOnFile = false;
            setLogoData(currentLogoData);
          }
        
      } else if(input == 'logo_on_file'){
          var tempUfileName = (name > 30) ? name.substring(0,30) + '...' : name;
          setPreviewImageLogoOnFile(url,tempUfileName);

          if(currentLogoData){
            currentLogoData.isLogoOnFile = true;
            currentLogoData.decoration_type = decoration_type;
            setLogoData(currentLogoData);
          }
          $('#hidden_upload_your_logo_name').val('');
      } else {
        $('.upload-logo-invalid-error').hide();
        $('.main-uploadlogo-container').removeClass('invalid-file-error');
        $('.main-uploadlogo-container').removeClass('photo-exists').attr('data-photo',false);
      }
      validateLogoOnFileDecoType();
    }

    /**
     * Update the preview image from the storage data
     * @param  {[type]} logoData [description]
     * @return {[type]}          [description]
     */
    var setPreviewUploadImageFromStorage = function(logoData) {
      var url = logoData.url;
      var name = logoData.name;
      var preview = $('#preview_uploaded_file');
      var logoValue = $('#hidden_upload_your_logo_name');
      $('.upload-logo-invalid-error').hide();
      $('.main-uploadlogo-container').removeClass('invalid-file-error');
      if (preview) { preview.attr('src', url); }
      if (logoValue) { logoValue.attr('value', url); }
      $('.main-uploadlogo-container').addClass('photo-exists').attr('data-photo',true);
      var tempUfileName = (name.length > 30) ? name.substring(0,30) + '...' : name;
      $('.main-uploadlogo-container .uploaded-img-name').text(tempUfileName);
    }

    /**
     * Handle the set logo preview logic
     * @param  {[type]}  value          [description]
     * @param  {Boolean} [isInput=true] [description]
     * @return {[type]}                 [description]
     */
    var setPreviewUploadImage = function(value, isInput) {
      if (isInput === undefined) {
        isInput = true;
      }
      if (isInput) {
        setPreviewUploadImageInput(value);
      } else {
        setPreviewUploadImageFromStorage(value);
      }
    };

    /**
     * Handle the Logo uploaded logic
     * Add the modal and display the uploaded image
     * @param  {string} btnType Set to "add" for new logo or "edit" for existing logo
     * @param  {boolean} skipScaleStep Set to true to skip the scaling step of the LMT (optional)
     * @return {[type]} [description]
     */

    






    var addLogoDesktop = function(btnType, skipScaleStep) {
        var newLogo = new Image();
        var logoSize;
        var sliceBar = $('#imageRange');
        var logoModal = $('#logoScaleModalDesktop');
        var logo = $('#logoImage');
        const scaleAreaOuter = document.querySelector('#scaleLogoModal .scale-area');
        console.log(scaleAreaOuter);
        console.log(scaleAreaOuter.offsetWidth, scaleAreaOuter.offsetHeight);
        scaleArea.width = $('#scaleLogoModal .scale-area').width();
        scaleArea.height = $('#scaleLogoModal .scale-area').height();
        if (btnType === 'add') {
            logoSize = loadedLogo.original_size;
        } else {
            logoSize = loadedLogo.transformed_size;
            if (loadedLogo.original_size.width > loadedLogo.original_size.height) {
              logoSize.width = scaleArea.width * loadedLogo.transformed_size.scale;
              logoSize.height = (logoSize.width / loadedLogo.original_size.width) * loadedLogo.original_size.height;
            } else {
              logoSize.height = scaleArea.height * loadedLogo.transformed_size.scale;
              logoSize.width = (logoSize.height / loadedLogo.original_size.height) * loadedLogo.original_size.width;
            }
        }
        // remove previous event handler
        newLogo.removeEventListener('load', logoLoad);
        $('.scale-area').off('gesture_move', pinchGesture);
        sliceBar.off('input', sliceBarInput);
        
        // Hold the spinner until the preview is actually on screen. 
        loadSpinner.show();
        newLogo.addEventListener('load', logoLoad);
        newLogo.addEventListener('error', logoLoadError);
        newLogo.src= loadedLogo.scalable_image_url;
        logo.attr("src", newLogo.src);
        $('.scale-area').gestureInit();
        // Initialize event listeners
        var browser = navigator.userAgent;
        if (-1 !== browser.search("MSIE") || -1 !== browser.search("Trident")){
            sliceBar.on('change', sliceBarInput);
        } else {
            sliceBar.on('input', sliceBarInput);
        }
        $('.scale-area').on('gesture_move', pinchGesture);

        // Set logo scale values
        tmpLogoScale.logoSize = logoSize;
        tmpLogoScale.logo = logo;
        tmpLogoScale.sliceBar = sliceBar;
        tmpLogoScale.btnType = btnType;
        tmpLogoScale.logoModal = logoModal;
        if (skipScaleStep) {
          tmpLogoScale.skipScaleStep = true;
        } else {
          tmpLogoScale.skipScaleStep = false;
        }
        
        $('#logoScaleModalDesktop .fileContainer, #logoScaleModalMobile .fileContainer').unbind('click', changeLogoClickHandler).bind('click', changeLogoClickHandler);
        
    };

    var logoLoad = function(e) {
      console.log("LOGO LOAD");
      console.log(scaleArea);
      var logoSize = tmpLogoScale.logoSize;
      var logo = tmpLogoScale.logo;
      var sliceBar = tmpLogoScale.sliceBar;
      var btnType = tmpLogoScale.btnType;
      var logoModal = tmpLogoScale.logoModal;
      var skipScaleStep = tmpLogoScale.skipScaleStep;
      // Calculate logo scale and size
      if (loadedLogo.original_size.height > loadedLogo.original_size.width) {
        sliceBar.attr('min', scaleArea.width*.2);
        if (btnType === 'add') {
          logo.height(scaleArea.height);
        } else {
          logo.height(logoSize.height);
        }
        logo.width(Math.round(loadedLogo.original_size.width*logo.height()/loadedLogo.original_size.height));
      } else {
        sliceBar.attr('min', scaleArea.height*.2);
        if (btnType === 'add') {
          logo.width(scaleArea.width);
        } else {
          logo.width(logoSize.width);
        }
        logo.height(Math.round(loadedLogo.original_size.height*logo.width()/loadedLogo.original_size.width));
      }
      setScaledSize({
        width: logo.width(),
        height: logo.height()
      }, scaleArea.width, 1);
      if (logoSize.height >= logoSize.width) {
          sliceBar.attr('max', scaleArea.height);
          sliceBar.val(loadedLogo.transformed_size.height);
      } else {
          sliceBar.attr('max', scaleArea.width);
          sliceBar.val(loadedLogo.transformed_size.width);
      }
      // Preview is loaded, hide spinner
      loadSpinner.hide();
      if (skipScaleStep) {
        // Skip the logoScaleModal and go right to setLogoSize
        setLogoSize();
      } else {
        logoModal.modal('show');
      }
    }

    var logoLoadError = function(e) {
      loadSpinner.hide();
      console.error('LMT could not load the logo preview image:', loadedLogo.scalable_image_url);
      $('#logoScaleModalDesktop').modal('hide');
      $('#logoScaleModalMobile').modal('hide');
      $('.allowedFiles')
        .html("We couldn't generate a preview for that logo. Please try re-saving it, or upload a different file.")
        .show();
    }

    var sliceBarInput = function (e) {
      var logoSize = tmpLogoScale.logoSize;
      var logo = tmpLogoScale.logo;
      var base = (logoSize.height >= logoSize.width) ? scaleArea.height: scaleArea.width;
      var scale = this.value / base;
        if (logoSize.height >= logoSize.width){
            logo.height(this.value);
            logo.width("auto");

        } else {
            logo.height("auto");
            logo.width(this.value);
        }
        setScaledSize({
          width: logo.width(),
          height: logo.height()
        }, scaleArea.width, scale);
    };

    var pinchGesture = function (e) {
      var logoSize = tmpLogoScale.logoSize;
      var logo = tmpLogoScale.logo;
      var sliceBar = tmpLogoScale.sliceBar;
      var logoNewSize;
      var scale = e.scale;
      var setValue = false;
      if (logoSize.height >= logoSize.width) {
          logoNewSize = logo.height()*scale;
          if (logoNewSize <= scaleArea.height && logoNewSize >= scaleArea.height*.2) {
              logo.height(logoNewSize);
              logo.width("auto");
              setValue = true;
          }
      } else {
          logoNewSize = logo.width()*scale;
          if (logoNewSize <= scaleArea.width && logoNewSize >= scaleArea.width*.2) {
              logo.height("auto");
              logo.width(logoNewSize);
              setValue = true;
          }
      }
      if (setValue) {
          setScaledSize({
            width: logo.width(),
            height: logo.height()
          }, scaleArea.width, scale);
          sliceBar.val(logoNewSize);
      }
    };


    /**
     * Clear data method
     * @return {[type]} [description]
     */
    var clear = function() {

      setLogoData({
          original_size: {
            height: "auto",
            width: "auto"
          },
          transformed_size: {
            height: 0,
            width: 0,
            base_width: 0,
            scale: 0
          },
          url: undefined,
          secure_url: undefined,
          scalable_image_url: undefined,
          public_id: undefined,
          original_filename: undefined,
          composition_url_desktop: undefined,
          composition_url_desktop_zoom: undefined,
      });

      saveToStorage('cloudinary_image', null);

      // restore image
      var logo = getLogoData();
      var selector = 'div.slick-track div.productSlideImageWrapp.slick-slide[data-slick-index="0"] img';
      $(selector).attr('src', logo['desktop_zoom_product_url']);
      selector = 'div.slick-track div.pinch-zoom-container.slick-slide[data-slick-index="0"] img';
      $(selector).attr('src', logo['desktop_product_url']);

    }
    
    var changeLogoClickHandler = function(e){
      if(inputFileObject == 'logo_on_file'){
        e.preventDefault();
        $('#logoScaleModalDesktop, #logoScaleModalMobile').modal('hide');
        $('#logoOnFileModal').modal('show');
        $('.user-create-account').hide();
        $('.user-login-form').show();
      }
    }
    
    var initLogoOnFile = function(proofImageUrl, proofNumber, decoration_type){
      $.ajax({
            type:'POST',
            url:'https://api.cloudinary.com/v1_1/merchology/auto/upload',
            data: {
              file: proofImageUrl,
              upload_preset:config.cloudinary.upload_preset
            },
            success:function(data){
              var typeVal = $('label.radioClicked input').val();
              if (typeVal == "Embroidered" || typeVal == "Sample") {
                $('.allowedFiles').hide();
              }
              // Display uploaded image
              var index = data.secure_url.lastIndexOf(".");
              var extension = data.secure_url.substring(index+1);
              var scalable_image_url = data.secure_url.substring(0,index+1)+'png';

              setLogoData({
                original_size: {
                  height: data.height,
                  width: data.width
                },
                url: data.url,
                secure_url: data.secure_url,
                scalable_image_url: scalable_image_url,
                public_id: data.public_id,
                original_filename: data.original_filename,
                proof_number: proofNumber,
                decoration_type: decoration_type,
              });
              inputFileObject = 'logo_on_file';
              // Add the selected logo to the LMT but skip the scaling step
              addLogoDesktop("add", true);
              validateLogoOnFileDecoType();
            },
            error: function(data){
              loadSpinner.hide();
              var logoScaleModal = $('#logoScaleModalDesktop');
              logoScaleModal.modal('hide');
              if(jQuery.type(data.message) === "string"){
                  $('.allowedFiles').html(data.message);
              } else {
                  $('.allowedFiles').html('Image file format not allowed. Allowed file types are: jpg, png, pdf, ai and psd');
              }
              $('.allowedFiles').show({
                complete: function() {
                  $('.allowedFiles').focus();
                }
              });
            }
        });
      
    }

    // Public API - Exposed methods
    return {
        initOnProductView: initOnProductView,
        saveLogoToStorage: saveLogoToStorage,
        getLogoFromStorage: getLogoFromStorage,
        setLogoData: setLogoData,
        getLogoData: getLogoData,
        setProductImage: setProductImage,
        disableLogoDisplay: disableLogoDisplay,
        enableLogoDisplay: enableLogoDisplay,
        addLogoDesktop: addLogoDesktop,
        clear: clear,
        initLogoOnFile:initLogoOnFile,
        setPreviewUploadImage:setPreviewUploadImage
    };

})();
